import React from 'react';

const DEFAULT_STATE = {};

export const ShareBottomSheetContext = React.createContext(DEFAULT_STATE);
